<ul class="step mb-3 mb-md-4 pb-lg-3 m-auto">
  <li
    *ngFor="let tab of tabs; let i = index"
    (click)="moveToStep(tab)"
    [ngClass]="{
      active: activeTab === tab,
      disabled: isTabDisabled(tab)
    }"
    class="step-item cursor-pointer"
  >
    <div class="step-content-wrapper">
      <span
        class="step-icon"
        [ngClass]="{
          extrass: activeTab === tab
        }"
        >{{ i + 1 }}</span
      >
      <div *ngIf="productGroupsPurchaseFlow" class="step-content">
        <span class="step-title">
          {{
            productGroupsPurchaseFlow[tab][
              'title_' + (this.configurationService.selectedLang$ | async)
            ]
          }}
        </span>
      </div>
    </div>
  </li>
</ul>
<!-- End Step -->

<!--Steps content-->
<booking-multi-day-dates-groups
  (onSubmit)="datesGroupsSubmit($event)"
  *ngIf="activeTab === 'datesGroups'"
  [isLoading]="(isLoadingProducts$ | async) || isLoadingProducts"
  [bookingDetails]="booking.details"
></booking-multi-day-dates-groups>

<step-02-rooms-form
  (onSubmit)="productGroupSubmit($event, 'rooms')"
  *ngIf="
    activeTab === 'rooms' &&
    (bookingIsLoading$ | async) === false &&
    (roomsProducts$ | async)?.length > 0
  "
  [bookingRooms]="booking.rooms"
  [booking]="booking"
  [datesList]="roomDateList"
  [products]="roomsProducts$ | async"
  [title]="'Rooms'"
>
</step-02-rooms-form>
<p *ngIf="(bookingIsLoading$ | async) === true && activeTab === 'rooms'">
  Booking loading...
</p>
<p *ngIf="(roomsProducts$ | async)?.length === 0 && activeTab === 'rooms'">
  {{ 'bookingModule.noProducts' | translate }}
</p>
<step-03-facilities-form
  (onSubmit)="productGroupSubmit($event, 'facilities')"
  *ngIf="
    activeTab === 'facilities' &&
    (bookingIsLoading$ | async) === false &&
    (facilitiesProducts$ | async)?.length > 0
  "
  [bookingFacilities]="booking.facilities"
  [booking]="booking"
  [datesList]="facilityDateList"
  [products]="facilitiesProducts$ | async"
>
</step-03-facilities-form>
<p *ngIf="(bookingIsLoading$ | async) === true && activeTab === 'facilities'">
  Booking loading...
</p>
<div
  *ngIf="
    (facilitiesProducts$ | async)?.length === 0 && activeTab === 'facilities'
  "
>
  <p>
    {{ 'bookingModule.noProducts' | translate }}
  </p>
  <div class="text-center">
    <button class="btn btn-primary w-100 d-block" (click)="nextTab('catering')">
      {{ 'bookingModule.continue' | translate }}
    </button>
  </div>
</div>

<step-04-catering-form
  (onSubmit)="productGroupSubmit($event, 'catering')"
  *ngIf="activeTab === 'catering' && (cateringProducts$ | async)?.length > 0"
  [bookingCatering]="booking.catering"
  [booking]="booking"
  [datesList]="cateringDateList"
  [products]="cateringProducts$ | async"
  [loading]="loading"
></step-04-catering-form>

<ng-container *ngIf="activeTab === 'completed'">
  {{ saleItems | json }}
</ng-container>
